/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_Details_PlaceholderInputs */

const en_pronunciation_report_details_placeholder = /** @type {(inputs: Pronunciation_Report_Details_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add context that might help us correct it.`)
};

const es_pronunciation_report_details_placeholder = /** @type {(inputs: Pronunciation_Report_Details_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega contexto que pueda ayudarnos a corregirlo.`)
};

/**
* | output |
* | --- |
* | "Add context that might help us correct it." |
*
* @param {Pronunciation_Report_Details_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_details_placeholder = /** @type {((inputs?: Pronunciation_Report_Details_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_Details_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_details_placeholder(inputs)
	return en_pronunciation_report_details_placeholder(inputs)
});